// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"7f4806ca","107":"a452766b","7297":"6ce6b713"}[chunkId] + ".chunk.css";
};